/**
 * workspaceLibraryStore — выбранная workspace-библиотека per project.
 *
 * P1.4 (2026-08-14): единая библиотека в Header применяется ко всем 4
 * вкладкам сразу. Чтобы при перезагрузке / смене проекта сохранялся
 * выбор (какой library сейчас активен), держим mapping projectId → libraryId
 * в localStorage (key: cs_workspace_library). Сам snapshot НЕ хранится —
 * он применяется в stores при выборе.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WorkspaceLibraryState {
  /** projectId → libraryId. */
  selectedByProject: Record<string, string>;
  select: (projectId: string, libraryId: string | null) => void;
  getSelected: (projectId: string | null) => string | null;
  clear: (projectId: string) => void;
}

export const useWorkspaceLibraryStore = create<WorkspaceLibraryState>()(
  persist(
    (set, get) => ({
      selectedByProject: {},

      select: (projectId, libraryId) => {
        if (!projectId) return;
        set((s) => {
          const next = { ...s.selectedByProject };
          if (libraryId) {
            next[projectId] = libraryId;
          } else {
            delete next[projectId];
          }
          return { selectedByProject: next };
        });
      },

      getSelected: (projectId) =>
        projectId ? get().selectedByProject[projectId] ?? null : null,

      clear: (projectId) =>
        set((s) => {
          const next = { ...s.selectedByProject };
          delete next[projectId];
          return { selectedByProject: next };
        }),
    }),
    {
      name: 'cs_workspace_library',
      // Персистим только mapping.
      partialize: (s) => ({ selectedByProject: s.selectedByProject }),
    },
  ),
);